import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { AppsFlyerQRCode } from "@faire/retailer-visitor-shared/icons/AppsFlyerQRCode/AppsFlyerQRCode";
import { AppModalType } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/AppDownload";
import { ViewAppLink } from "@faire/retailer-visitor-shared/components/MobileAppPromoBanner/ViewAppLink";
var QR_CODE_WIDTH = 120;
export var QRAppSection = function(props) {
    var getQRImageUrl = function() {
        if (props.appModalType === AppModalType.APPSTORE) {
            return "https://cdn.faire.com/fastly/3d77d319b263789c7bf9e0d352daa4d5f80ace5d3a1d46f1d532d4c6b7a13c71.png";
        }
        return "https://cdn.faire.com/fastly/9f4d40b9074c96c857d8b582a6eb90d93bae0e7672e670ac4382bdef66c0ca6a.png";
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "4yQCZD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Scan this QR code with your mobile phone to download the App."
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx(AppsFlyerQRCode, {
                        qrCodeWidth: QR_CODE_WIDTH,
                        fallbackQrCodeUrl: getQRImageUrl()
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(ViewAppLink, {
                        appModalType: props.appModalType
                    })
                ]
            })
        ]
    });
};
